/**
 * @Author: DJ
 * @Date:   2021-07-08 15:54:02
 * @Last Modified by:   DJ
 * @Last Modified time: 2021-09-04 09:27:31
 */
/**
 * 骑士信息
 */
import React, { useEffect,useState } from 'react';
import styles from './certificateInfo.module.scss';
import { tooltipStyle, tooltip, ImgCell } from '@/components/TableCell';
import { Avatar, Button, DatePicker, Form, Input, Table } from 'antd';
import { XLineBackBtn, XTitle, XMediaFn } from '@/components/xqxc_ui';
import { jkzPicDetail, jkzDetail,riderDetail } from './api';
import InfoLabel from '@/components/InfoLabel';


const Index = (props) => {
    const [viewData, setViewData] = useState(null);
    // const [ riderData, setRiderData] = useState({});
    // const [imgData, setImgData] = useState({});
    useEffect(()=>{
        // eslint-disable-next-line react/prop-types
        jkzDetail({id:props.match.params.id,loginUserId:props.match.params.loginUserId}).then(res=>{
            if(res && res.errCode===0){
                setViewData(res.result);
            }
        });
    },[]);

    // useEffect(()=>{
    //     // eslint-disable-next-line react/prop-types
    //     riderDetail({riderId:props.match.params.riderId}).then(res=>{
    //         if(res && res.errCode===0){
    //             setRiderData(res.result);
    //         }
    //     });
    // },[]);

    // useEffect(()=>{
    //     // eslint-disable-next-line react/prop-types
    //     jkzPicDetail(props.match.params).then(res=>{
    //         if(res && res.errCode===0){
    //             setImgData(res.result);
    //         }
    //     });
    // },[]);

    const columns = [
        {
            title: '操作人',
            key: 'auditUserName',
            dataIndex: 'auditUserName',
            align: 'center',
            width: 120,
            onCell: tooltipStyle,
            render: tooltip,
        },
        {
            title: '操作内容',
            key: 'opContent',
            dataIndex: 'opContent',
            align: 'center',
            width: 240,
            onCell: tooltipStyle,
            render: tooltip,
        },
        {
            title: '操作时间',
            key: 'gmtCreateStr',
            dataIndex: 'gmtCreateStr',
            align: 'center',
            width: 150,
            onCell: tooltipStyle,
            render: tooltip,
        },
    ];
    return (
        <div className={`${styles.flexBoxContainer} ${styles.scroll}`}>
            {viewData && <div className={`${styles.container} ${styles.scrollContainer}`}>
                <div className={styles.user}>
                    <Avatar size={80} icon='u' src={ viewData.riderDetailResp.headUrl} />
                    <div className={styles.info}>
                        <div className={styles.rider}>
                            <div className={styles.name}>姓名：{viewData.riderDetailResp.realName}</div>
                            <div className={styles.state}>
                            {viewData.riderDetailResp.workStateValue}
                            </div>
                            
                        </div>
                        <div className={styles.contact}>
                            <InfoLabel
                                style={{ marginRight: '30px' }}
                                label='手机号码：'
                                value={viewData.riderDetailResp.mobilePhone}
                            />
                        </div>
                    </div>
                </div>

                <div className={styles.baseinfo}>
                    <XTitle label='基本信息' />
                    <div className={styles.cols}>
                        <div className={styles.col}>
                            <InfoLabel label='骑士等级：' value={viewData.riderDetailResp.levelName} />
                            {/* <InfoLabel label='推荐人：' value={''} />
                            <InfoLabel
                                label='最后登录时间：'
                                value={''}
                            /> */}
                        </div>
                        <div className={styles.col}>
                            <InfoLabel
                                label='当前服务区域：'
                                value={viewData.riderDetailResp.serviceArea}
                            />
                        </div>
                        <div className={styles.col}>
                            <InfoLabel
                                label='所属运营公司：'
                                value={viewData.riderDetailResp.operationsName}
                            />
                            {/* <InfoLabel
                                label='注册时间：'
                                value={registerTime}
                            /> */}
                        </div>
                    </div>
                </div>
                <div className={styles.auth}>
                    <XTitle label='实名信息' />
                    <div className={styles.cols}>
                        <div className={styles.col}>
                            <InfoLabel label='证件号码：' value={viewData.riderDetailResp.idCardCode} />
                        </div>
                        <div className={styles.col}>
                            <InfoLabel label='地区：' value={viewData.riderDetailResp.address} />
                        </div>
                        <div className={styles.col}>
                            <InfoLabel label='性别：' value={viewData.riderDetailResp.sexValue} />
                        </div>
                    </div>
                    <div className={styles.imgs}>
                        <div className={styles.img}>
                            <div className={styles.label}>身份证正面:</div>
                            <XMediaFn
                                style={{ width: '280px', height: '175px' }}
                                dataType='image'
                                dataSource={viewData.riderDetailResp.idFrontUrl}
                            />
                        </div>
                        <div className={styles.img}>
                            <div className={styles.label}>身份证反面:</div>
                            <XMediaFn
                                style={{ width: '280px', height: '175px' }}
                                dataType='image'
                                dataSource={viewData.riderDetailResp.idBackUrl}
                            />
                        </div>
                        <div className={styles.img}></div>
                    </div>
                </div>
                <div className={styles.auth}>
                    <XTitle label='健康证信息' />
                    <div className={styles.imgs}>
                        <div className={styles.img}>
                            <div className={styles.label}>健康证正面:</div>
                            <XMediaFn
                                style={{ width: '280px', height: '175px' }}
                                dataType='image'
                                dataSource={viewData.certificateFront}
                            />
                        </div>
                        <div className={styles.img}>
                            <div className={styles.label}>健康证反面:</div>
                            <XMediaFn
                                style={{ width: '280px', height: '175px' }}
                                dataType='image'
                                dataSource={viewData.certificateBack}
                            />
                        </div>
                        <div className={styles.img}></div>
                    </div>
                    <div className={styles.cols}>
                        <div className={styles.col}>
                            <InfoLabel label='有效期：' value={viewData.validityBeginDate+' - '+viewData.validityEndDate} />
                        </div>
                    </div>
                </div>
                { viewData.auditOpinion && <div className={styles.auth}>
                    <XTitle label='审核信息' />
                    <InfoLabel label='审核建议：' value={viewData.auditOpinion || ' '} />
                </div>}
                {viewData.logList.length>0 &&<div className={styles.auth}>
                    <XTitle label='操作日志' />
                    <Table
                        columns={columns}
                        dataSource={viewData.logList}
                        rowKey='deliveryId'
                        pagination={false}
                        // fixed={true}
                        // scroll={{ y: false }}
                    />
                </div>}
            </div>}
            <XLineBackBtn
                style={{ marginTop: '10px' }}
                // eslint-disable-next-line react/prop-types
                cancelHandle={props.history.goBack}
                label='返回'
            />
            {/* {this._renderModal()} */}
        </div>
    );
};

export default Index;
